function getSessionStorage() {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function safeGetSessionStorageItem(key: string) {
  const sessionStorage = getSessionStorage();

  if (!sessionStorage) {
    return null;
  }

  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeSetSessionStorageItem(key: string, value: string) {
  const sessionStorage = getSessionStorage();

  if (!sessionStorage) {
    return;
  }

  try {
    sessionStorage.setItem(key, value);
  } catch {
    return;
  }
}

export function safeRemoveSessionStorageItem(key: string) {
  const sessionStorage = getSessionStorage();

  if (!sessionStorage) {
    return;
  }

  try {
    sessionStorage.removeItem(key);
  } catch {
    return;
  }
}
